/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeSystemBlocks.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   System Blocks Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Sunday, September 23, 2018 - 3:04 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/23/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const SYSTEMBLOCK_LIST_CONTAINER_LOADED = 'SYSTEMBLOCK_LIST_CONTAINER_LOADED';
export const SYSTEMBLOCK_LIST_CONTAINER_UNLOADED = 'SYSTEMBLOCK_LIST_CONTAINER_UNLOADED';
export const SYSTEMBLOCK_LIST_TABLE_LOADED = 'SYSTEMBLOCK_LIST_TABLE_LOADED';
export const SYSTEMBLOCK_LIST_TABLE_UNLOADED = 'SYSTEMBLOCK_LIST_TABLE_UNLOADED';
export const SYSTEMBLOCK_LIST_CHANGE_COMPANY = 'SYSTEMBLOCK_LIST_CHANGE_COMPANY';
export const SYSTEMBLOCK_LIST_CHANGE_LISTGROUP = 'SYSTEMBLOCK_LIST_CHANGE_LISTGROUP';
export const SYSTEMBLOCK_SELECT_ROW = 'SYSTEMBLOCK_SELECT_ROW';
export const SYSTEMBLOCK_ADD = 'SYSTEMBLOCK_ADD';
export const SYSTEMBLOCK_EDIT = 'SYSTEMBLOCK_EDIT';
export const SYSTEMBLOCK_DELETE = 'SYSTEMBLOCK_DELETE';
export const SYSTEMBLOCK_DELETE_DISABLE = 'SYSTEMBLOCK_DELETE_DISABLE';
export const SYSTEMBLOCK_OPEN_WARNING = 'SYSTEMBLOCK_OPEN_WARNING';
export const SYSTEMBLOCK_CLOSE_WARNING = 'SYSTEMBLOCK_CLOSE_WARNING';
export const SYSTEMBLOCK_VIEW_LISTITEMS = 'SYSTEMBLOCK_VIEW_LISTITEMS';

export const SYSTEMBLOCK_EDIT_CONTAINER_LOADED = 'SYSTEMBLOCK_EDIT_CONTAINER_LOADED';
export const SYSTEMBLOCK_EDIT_CONTAINER_UNLOADED = 'SYSTEMBLOCK_EDIT_CONTAINER_UNLOADED';
export const SYSTEMBLOCK_EDIT_FORM_LOADED = 'SYSTEMBLOCK_EDIT_FORM_LOADED';
export const SYSTEMBLOCK_EDIT_FORM_UNLOADED = 'SYSTEMBLOCK_EDIT_FORM_UNLOADED';
export const SYSTEMBLOCK_EDIT_LOAD_LISTGROUPS = 'SYSTEMBLOCK_EDIT_LOAD_LISTGROUPS';
export const SYSTEMBLOCK_EDIT_CHANGE_COMPANY = 'SYSTEMBLOCK_EDIT_CHANGE_COMPANY';
export const SYSTEMBLOCK_EDIT_DATA_LOAD = 'SYSTEMBLOCK_EDIT_DATA_LOAD';
export const SYSTEMBLOCK_SET_COMPANY_SELECT = 'SYSTEMBLOCK_SET_COMPANY_SELECT';
export const SYSTEMBLOCK_SET_LISTGROUP_SELECT = 'SYSTEMBLOCK_SET_LISTGROUP_SELECT';
export const SYSTEMBLOCK_EDIT_CONTAINER_SUBMIT = 'SYSTEMBLOCK_EDIT_CONTAINER_SUBMIT';
export const SYSTEMBLOCK_EDIT_CONTAINER_CANCEL = 'SYSTEMBLOCK_EDIT_CONTAINER_CANCEL';

export const SYSTEMBLOCK_TEST = 'SYSTEMBLOCK_TEST';


// WEBPACK FOOTER //
// ./src/constants/actionTypeSystemBlocks.js